import React from "react";
import cx from "classnames";
import styles from "./NewsThumbNailLoadingSkeleton.module.css";
import Skeleton from "@mui/material/Skeleton";

const NewsThumbNailLoadingSkeleton = () => {
  return (
    <div
      className={cx(
        styles.container,
        "d-flex",
        "flex-column",
        "align-items-start",
        "justify-content-start",
        "w-100"
      )}
    >
      <Skeleton
        className={cx(styles.mainSkeletonStyles)}
        variant="rectangular"
        height={"100%"}
        width={"100%"}
      />

      <Skeleton
        className={cx(styles.skeletonStyles, styles.textStyles)}
        variant="rectangular"
        height={25}
        width={"100%"}
      />
      <Skeleton
        className={cx(styles.skeletonStyles, styles.textStyles)}
        variant="rectangular"
        height={25}
        width={"40%"}
      />
      <Skeleton
        className={cx(
          styles.skeletonStyles,
          styles.textStyles,
          "mt-auto",
          "mb-4"
        )}
        variant="rectangular"
        height={25}
        width={"30%"}
      />
    </div>
  );
};

export default NewsThumbNailLoadingSkeleton;
